/*------------------------------------------------------------------------------
01. Lenis
02. Preloader
03. Sticky Header
04. One Page Navigation
05. Scroll To Top
06. Wow animation - on scroll
07. Parallax
08. Video
09. Tab Effect
10. Resize function
11. FullScreenHeight function
12. ScreenFixedHeight function
13. FullScreenHeight and screenHeight with resize function
14. Sliders
15. Tabs
16. CountUp
17. Countdown
18. Isotop
-------------------------------------------------------------------------------- */

/*------------------------------------------------------------------------------
01. Lenis - Smooth Scroll (https://github.com/darkroomengineering/lenis)
-------------------------------------------------------------------------------- */
import Lenis from "@studio-freight/lenis";

window.lenisJs = Lenis

document.addEventListener("turbo:load", function () {
  // document.querySelector("#preloader").fadeOut('normall', function() {
  //   $(this).remove();
  // });

  const lenis = new Lenis({
    smooth: false
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  const scrollTopButton = document.querySelector("#scrollTopButton");
  
  if (scrollTopButton) {
    scrollTopButton.addEventListener("click", function () {
      lenis.scrollTo(0, {
        duration: 0.6,
      });
    });

    document.addEventListener("scroll", function () {
      if (window.scrollY > 300) {
        scrollTopButton.style.display = "block";
      } else {
        scrollTopButton.style.display = "none";
      }
    });
  }
});

/*------------------------------------------------------------------------------
-------------------------------------------------------------------------------- */

// document.addEventListener("turbo:load", function () {
//   (function($) {

//     "use strict";

//     var $window = $(window);

//     /*------------------------------------
//     01. scrollIt
//     --------------------------------------*/
//     $.scrollIt({
//       upKey: 38,                // key code to navigate to the next section
//       downKey: 40,              // key code to navigate to the previous section
//       easing: 'linear',          // the easing function for animation
//       scrollTime: 600,          // how long (in ms) the animation takes
//       activeClass: 'active',    // class given to the active nav element
//       onPageChange: null,       // function(pageIndex) that is called when page is changed
//       topOffset: -100            // offste (in px) for fixed top navigation
//     });

//     /*------------------------------------
//     02. Preloader
//     --------------------------------------*/

//     $('#preloader').fadeOut('normall', function() {
//       $(this).remove();
//     });


//     /*------------------------------------
//     04. One Page Navigation
//     --------------------------------------*/

//     if ($window.width() <= 991) {
//       $('.onepage-header .navbar-nav .nav-link').on("click", function() {
//         $('.navbar-nav').css("display", "none");
//         $('.navbar .navbar-toggler').removeClass('menu-opened');
//       });
//     }

//     /*------------------------------------
//     05. Scroll To Top
//     --------------------------------------*/

//     $window.on('scroll', function() {
//       if ($(this).scrollTop() > 500) {
//         $(".scroll-to-top").fadeIn(400);

//       } else {
//         $(".scroll-to-top").fadeOut(400);
//       }
//     });

//     $(".scroll-to-top").on('click', function(event) {
//       event.preventDefault();
//       $("html, body").animate({
//         scrollTop: 0
//       }, 600);
//     });


//     /*------------------------------------
//     06. Wow animation - on scroll
//     --------------------------------------*/

//     var wow = new WOW({
//       boxClass: 'wow', // default
//       animateClass: 'animated', // default
//       offset: 0, // default
//       mobile: false, // default
//       live: true // default
//     })
//     wow.init();


//     /*------------------------------------
//     07. Parallax
//     --------------------------------------*/

//     // sections background image from data background
//     var pageSection = $(".parallax,.bg-img");
//     pageSection.each(function(indx) {

//       if ($(this).attr("data-background")) {
//         $(this).css("background-image", "url(" + $(this).data("background") + ")");
//       }
//     });


//     /*------------------------------------
//     08. Video
//     --------------------------------------*/

//     $('.story-video').magnificPopup({
//       delegate: '.video',
//       type: 'iframe'
//     });

//     /*------------------------------------
//     09. Tab Effect
//     --------------------------------------*/

//     //Click on first li element
//     $( "#tab1" ).click(function() {
//       $( "#second, #third" ).fadeOut();
//       $( "#first" ).fadeIn(1000);
//     });

//     //Click on second li element
//     $( "#tab2" ).click(function() {
//       $( "#first, #third" ).fadeOut();
//       $( "#second" ).fadeIn(1000);
//     });

//     //Click on third li element
//     $( "#tab3" ).click(function() {
//       $( "#second, #first" ).fadeOut();
//       $( "#third" ).fadeIn(1000);
//     });

//     /*------------------------------------
//     10. Resize function
//     --------------------------------------*/

//     $window.resize(function(event) {
//       setTimeout(function() {
//         SetResizeContent();
//       }, 500);
//       event.preventDefault();
//     });


//     /*------------------------------------
//     11. FullScreenHeight function
//     --------------------------------------*/

//     function fullScreenHeight() {
//       var element = $(".full-screen");
//       var $minheight = $window.height();
//       // element.css('min-height', $minheight);
//     }

//     function LogoScreenChange() {
//       var innerlogo = $(".navbar-brand.inner-logo img");
//       if ($window.width() >= 992) {
//         innerlogo.attr('src', '/assets/logos/opsico-white.png');
//       } else {
//         innerlogo.attr('src', '/assets/logos/logo.png');
//       }
//     }

//     /*------------------------------------
//     12. ScreenFixedHeight function
//     --------------------------------------*/

//     function ScreenFixedHeight() {
//       var $headerHeight = $("header").height();
//       var element = $(".screen-height");
//       var $screenheight = $window.height() - $headerHeight;
//       element.css('height', $screenheight);
//     }

//     /*------------------------------------
//     13. FullScreenHeight and screenHeight with resize function
//     --------------------------------------*/

//     function SetResizeContent() {
//       fullScreenHeight();
//       ScreenFixedHeight();
//       LogoScreenChange();
//     }

//     SetResizeContent();

//     // === when document ready === //
//     $(document).on("ready", function() {

//       /*------------------------------------
//       14. Sliders
//       --------------------------------------*/

//       // Testmonials carousel1
//       $('#testmonials-carousel').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         smartSpeed: 800,
//         nav: false,
//         dots: true,
//         center: true,
//         margin: 0,
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 3
//           },
//           992: {
//             items: 3
//           }
//         }
//       });

//       // App screenshot slide
//       $(".app_screenshots_slides").owlCarousel({
//         items: 1,
//         loop: true,
//         autoplay: true,
//         smartSpeed: 800,
//         margin: 30,
//         center: true,
//         dots: true,
//         responsive: {
//           0: {
//             items: 1
//           },
//           576: {
//             items: 2
//           },
//           768: {
//             items: 3
//           },
//           992: {
//             items: 4
//           },
//           1200: {
//             items: 5
//           }
//         }
//       });

//       // Testmonial carousel1
//       $('.testmonial-carousel').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         smartSpeed: 800,
//         nav: true,
//         dots: false,
//         center:true,
//         margin: 0,
//         navText: ["<span>&#10229;</span>", "<span>&#10230;</span>"],
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 1
//           },
//           992: {
//             items: 1
//           }
//         }
//       });

//       // testmonial-6 carousel1
//       $('.testmonial-style2').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         smartSpeed: 800,
//         nav: true,
//         dots: true,
//         center:false,
//         margin: 0,
//         navText: ["<i class='ti-arrow-left'></i>", "<i class='ti-arrow-right'></i>"],
//         responsive: {
//           0: {
//             items: 1,
//             dots: false
//           },
//           768: {
//             items: 1
//           },
//           992: {
//             items: 1
//           }
//         }
//       });

//       // testmonial-6 carousel1
//       $('.testmonial-style3').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         smartSpeed: 800,
//         nav: false,
//         dots: false,
//         center:false,
//         margin: 0,
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 2
//           },
//           992: {
//             items: 3
//           }
//         }
//       });

//       // screenshort4 carousel1
//       $('#screenshort-carousel').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         smartSpeed: 800,
//         nav: false,
//         dots: true,
//         center:true,
//         margin: 20,
//         responsive: {
//           0: {
//             items: 2
//           },
//           768: {
//             items: 3
//           },
//           992: {
//             items: 5
//           }
//         }
//       });

//       // Partners carousel
//       $('#partners').owlCarousel({
//         loop: true,
//         nav: false,
//         dots: false,
//         autoplay: true,
//         autoplayTimeout: 3000,
//         responsiveClass: true,
//         autoplayHoverPause: false,
//         responsive: {
//           0: {
//             items: 2,
//             margin: 20
//           },
//           768: {
//             items: 3,
//             margin: 40,
//           },
//           992: {
//             items: 5,
//             margin: 60,
//           },
//           1200: {
//             items: 6,
//             margin: 40,
//           }
//         }
//       });

//       // carousel2
//       $('#carousel-style2').owlCarousel({
//         loop: true,
//         responsiveClass: true,
//         autoplay: true,
//         autoplayTimeout: 3000,
//         smartSpeed: 800,
//         nav: false,
//         dots: false,
//         center:false,
//         margin: 0,
//         responsive: {
//           0: {
//             items: 1
//           },
//           768: {
//             items: 2
//           },
//           992: {
//             items: 2
//           },
//           1200: {
//             items: 3
//           },
//           1600: {
//             items: 4
//           }
//         }
//       });

//       // Default owlCarousel
//       // $('.owl-carousel').owlCarousel({
//       //   items: 1,
//       //   loop: true,
//       //   dots: false,
//       //   margin: 0,
//       //   autoplay: true,
//       //   smartSpeed: 500
//       // });

//       /*------------------------------------
//       15. Tabs
//       --------------------------------------*/

//       //Horizontal Tab
//       if ($(".horizontaltab").length !== 0) {
//         $('.horizontaltab').easyResponsiveTabs({
//           type: 'default', //Types: default, vertical, accordion
//           width: 'auto', //auto or any width like 600px
//           fit: true, // 100% fit in a container
//           tabidentify: 'hor_1', // The tab groups identifier
//           activate: function(event) { // Callback function if tab is switched
//             var $tab = $(this);
//             var $info = $('#nested-tabInfo');
//             var $name = $('span', $info);
//             $name.text($tab.text());
//             $info.show();
//           }
//         });
//       }

//       // Child Tab
//       if ($(".childverticaltab").length !== 0) {
//         $('.childverticaltab').easyResponsiveTabs({
//           type: 'vertical',
//           width: 'auto',
//           fit: true,
//           tabidentify: 'ver_1', // The tab groups identifier
//           activetab_bg: '#fff', // background color for active tabs in this group
//           inactive_bg: '#F5F5F5', // background color for inactive tabs in this group
//           active_border_color: '#c1c1c1', // border color for active tabs heads in this group
//           active_content_border_color: '#c1c1c1' // border color for active tabs contect in this group so that it matches the tab head border
//         });
//       }

//       //Vertical Tab
//       if ($(".verticaltab").length !== 0) {
//         $('.verticaltab').easyResponsiveTabs({
//           type: 'vertical', //Types: default, vertical, accordion
//           width: 'auto', //auto or any width like 600px
//           fit: true, // 100% fit in a container
//           closed: 'accordion', // Start closed if in accordion view
//           tabidentify: 'hor_1', // The tab groups identifier
//           activate: function(event) { // Callback function if tab is switched
//             var $tab = $(this);
//             var $info = $('#nested-tabInfo2');
//             var $name = $('span', $info);
//             $name.text($tab.text());
//             $info.show();
//           }
//         });
//       }

//       /*------------------------------------
//       16. CountUp
//       --------------------------------------*/

//       $('.countup').counterUp({
//         delay: 25,
//         time: 2000
//       });

//       /*------------------------------------
//       17. Countdown
//       --------------------------------------*/

//       // CountDown for coming soon page
//       $(".countdown").countdown({
//         date: "01 Jan 2021 00:01:00", //set your date and time. EX: 15 May 2014 12:00:00
//         format: "on"
//       });


//       $(".slow-redirect a[href^='#']").click(function(e) {
//         e.preventDefault();

//         var position = $($(this).attr("href")).offset().top - 85;

//         $("body, html").animate({
//           scrollTop: position
//         }, 1000);
//       });

//     });

//     // === when window loading === //
//     $window.on("load", function() {

//       /*------------------------------------
//       18. Isotop
//       --------------------------------------*/

//       // isotope with magnificPopup
//       $('.gallery').magnificPopup({
//         delegate: '.popimg',
//         type: 'image',
//         gallery: {
//           enabled: true
//         }
//       });

//       var $gallery = $('.gallery').isotope({
//         // options
//       });


//       // filter items on button click
//       $('.filtering').on('click', 'span', function() {
//         var filterValue = $(this).attr('data-filter');
//         $gallery.isotope({
//           filter: filterValue
//         });
//       });

//       $('.filtering').on('click', 'span', function() {
//         $(this).addClass('active').siblings().removeClass('active');
//       });

//       // stellar
//       $window.stellar();

//       $( ".tabs_div" ).toggleClass("tabs_div_visible");

//     });

//   })(jQuery);
// });
